/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

const NoteWidget = ({
  className = '',
  data,
  setShowModalDeviceNoteDetail,
  setSelectedDeviceNote,
}) => {
  return (
    <div>
      <div className={`card ${className}`}>
        <div className='card-body d-flex align-items-center pt-4 pb-4'>
          <div className='d-flex flex-column flex-grow-1'>
            <div
              className='fw-bold fs-5 mb-1 text-primary pointer'
              style={{cursor: 'pointer'}}
              onClick={() => {
                setShowModalDeviceNoteDetail(true)
                setSelectedDeviceNote(data)
              }}
            >
              {data?.deviceId}
            </div>
            <div className='fw-bold fs-5 mb-2'>{data?.deviceName}</div>
            <div className='fw-bold fs-3 mb-2'>{data?.noteHeader}</div>
            <div className='text-muted fw-semibold fs-5 mb-2'>{data?.note}</div>
            <div className='text-muted fw-semibold fs-7 mb-2'>
              {getTimeFormat(data?.createdAt?.seconds)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {NoteWidget}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
